export default "__VITE_ASSET__aff2bf99__"